import { render } from "./QueryReply.vue?vue&type=template&id=c672c560&scoped=true"
import script from "./QueryReply.vue?vue&type=script&lang=js"
export * from "./QueryReply.vue?vue&type=script&lang=js"

import "./QueryReply.vue?vue&type=style&index=0&id=c672c560&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c672c560"]])

export default __exports__